module.exports = __webpack_public_path__ + "media/home-coffee.8091342d.mp4";